import { render, staticRenderFns } from "./BXbcsjkfb.vue?vue&type=template&id=01edd99e"
import script from "./BXbcsjkfb.vue?vue&type=script&lang=js"
export * from "./BXbcsjkfb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports